import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useRef, useState, useMemo } from 'react';
import '../../CSS/Global.css';
import './ProductFormPage.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../SideBar';
import Header from '../Header';
import Select from 'react-select';
import ReactQuill from 'react-quill-new';
import 'quill/dist/quill.snow.css';
import ImageModalEquip from '../Modal/ImageModalProd';
import ImageModalDownloadable from '../Modal/ImageModalDownloadble';
import ImageModalGallery from '../Modal/ImageModalGallery';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { X } from 'lucide-react';
import { decryptToken } from '../utils/getToken';
import { getDiscountValidationError } from './productPricingValidation';
import {
    resolveBrandName,
    matchCategoryOption,
    matchBrandOption,
    preserveSelectOption,
} from './productSelectUtils';
import ProductButtonOptions from "./ProductButtonOptions";
import ProductSeoFields from './ProductSeoFields';
import AIProductAssistant from './AIProductAssistant';
import ProductFormSection from './ProductFormSection';
import ProductFormChrome from './ProductFormChrome';
import FormLabel from './FormLabel';
import SortableSpecItem from './SortableSpecItem';
import { calculateGroupedProductCompletion } from './productFormCompletion';
import Swal from 'sweetalert2';
import {
    DndContext,
    closestCenter
} from "@dnd-kit/core";

import {
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
    arrayMove
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";

function convertToWords(num) {
    num = Number(num);
    if (isNaN(num) || num <= 0) return '';
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
        'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
        'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
        'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const numberToWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + numberToWords(n % 100) : "");
        if (n < 100000) return numberToWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + numberToWords(n % 1000) : "");
        if (n < 10000000) return numberToWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + numberToWords(n % 100000) : "");
        return numberToWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + numberToWords(n % 10000000) : "");
    };

    return numberToWords(Number(num));
}

const getFileIcon = (url) => {
    const urlmain = API_BASE_URL
    if (!url || typeof url !== 'string') return "/icons/file.png";
    const ext = url.split('.').pop().toLowerCase();

    if (["jpg", "jpeg", "png", "webp", "gif", "bmp", "svg"].includes(ext)) {
        return `${urlmain}${url}`; // return actual image
    }

    if (["xlsx", "xls", "csv"].includes(ext)) return "/icons/excel.png";
    if (["pdf"].includes(ext)) return "/icons/pdf.webp";
    if (["doc", "docx"].includes(ext)) return "/icons/word.png";
    if (["ppt", "pptx"].includes(ext)) return "/icons/ppt.png";
    if (["mp4", "mov", "avi", "mkv"].includes(ext)) return "/icons/video.png";
    if (["mp3", "wav", "aac", "flac", "m4a"].includes(ext)) return "/icons/audio.png";
    if (["zip", "rar"].includes(ext)) return "/icons/zip.png";
    if (["txt", "cls"].includes(ext)) return "/icons/text.png";

    return "/icons/file.png"; // default file icon
};

const calculateSalePrice = (data) => {

    const mrp = Number(data.originalPrice) || 0;

    let salePrice = 0;

    if (data.discount_type === "price") {
        const discount = Number(data.discount_price) || 0;
        salePrice = mrp - discount;
    }

    if (data.discount_type === "percentage") {
        const discount = Number(data.discount_percentage) || 0;
        salePrice = mrp - (mrp * discount) / 100;
    }

    if (salePrice < 0) salePrice = 0;

    return salePrice.toFixed(2);
};

function SortableKeyFeature({ feature, setFormData }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: feature.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <li
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="oms-tag-item"
    >
      {feature.text}

      <X
        type="button"
        className="oms-tag-delete"
        onClick={() => {
          setFormData(prev => ({
            ...prev,
            key_features: prev.key_features.filter(
              f => f.id !== feature.id
            )
          }));
        }}
        size={14}
      />
    </li>
  );
}

const GroupedProductEdit = () => {
    const { id } = useParams();
    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    const [keyFeatureInput, setKeyFeatureInput] = useState('');
    const [specInput, setSpecInput] = useState({ label: '', value: '' });
    if (user) {
        console.log("✅ User:", user);
    } else {
        console.log("⚠️ User not found or decryption failed.");
    }

    const url = API_BASE_URL
    const token = decryptToken("accessToken") || ""
    const [formData, setFormData] = useState({
        image: [],
        gallery: [],
        title: '',
        originalPrice: '',
        discountPrice: '',
        product_type: { value: 'Grouped Product', label: 'Grouped Product' },
        category: null,
        categorytype: "",
        total: '',
        stock: '',
        status: null,
        short_description: "",
        description: "",
        grouped_products: [],
        stock: "",
        weight: "",
        length: "",
        width: "",
        height: "",
        user_id: "",
        user_name: "",
        delivery_days: "",
        key_features: [],
        specifications: [],
        meta_title: "",
        meta_description: "",
        meta_keywords: [],
        tags: [],
        faqs: [],
        category_id: "",
        categorytype_id: [],
        warranty: "Yes",
        warranty_from: "",
        warranty_note: "",
        brand_name: "",
        installation: "",
        installation_fee: "",
        brand_id: [],
        gst_type: "included",
        gst_percentage: "",
        hsn: "",
        discount_type: "price",
        discount_price: "",
        discount_percentage: "",
        add_to_cart: false,
        buy_now: false,
        inquiry: false,
    });
    const [availableSizes] = useState(["XS", "S", "M", "L", "XL", "XXL"]);
    const [selectedSizes, setSelectedSizes] = useState([]);
    const [variationsAccordion, setVariationsAccordion] = useState([]);
    const [showVariations, setShowVariations] = useState(false);
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [brand, setBrand] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [savingDraft, setSavingDraft] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showVariationPopup, setShowVariationPopup] = useState(false);


    const attributeOptions = [
        { value: 'size', label: 'Size' },
        { value: 'weight', label: 'Weight' },
        { value: 'length', label: 'Length' },
        { value: 'thickness', label: 'Thickness' },
        // Add more as needed
    ];

    const sizeOptions = [
        { value: 'S', label: 'S' },
        { value: 'M', label: 'M' },
        { value: 'L', label: 'L' },
        { value: 'XL', label: 'XL' },
        { value: 'XXL', label: 'XXL' },
    ];

    const fetchCategories = async () => {
        try {
            const response = await fetch(`${url}/category/getdata/category/${user.main_id}`, {
                method: "GET",
                // credentials: "include"
            })
            const res = await response.json();
            const options = res.map(cat => ({
                value: cat.category || cat.category || cat.id,
                label: cat.category || cat.category || cat.category,
                id: cat.id
            }));
            setCategories(options);
        } catch (error) {
            console.error(error)
        }
    }

    const fetchBrand = async () => {
        try {
            const response = await fetch(`${url}/brand/getall`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();

            const options = res.data.map(cat => ({
                value: cat.id,
                label: cat.name || cat.name || "Unnamed Category",
                id: cat.id
            }));

            // Add the dummy "Select" option at the top


            setBrand(options);
        } catch (error) {
            console.error(error);
        }
    };


    const [showImageModal, setShowImageModal] = useState(false);
    const [images, setImages] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [showImageModalGallery, setShowImageModalGallery] = useState(false);
    const [imagesGallery, setImagesGallery] = useState([]);
    const [productSingle, setProductSingle] = useState({});
    const [productRaw, setProductRaw] = useState(null);
    const productHydratedRef = useRef(false);

    const [isUploadModalOpen, setUploadModalOpen] = useState(false);


    const [variations, setVariations] = useState([]);
    const [variationDetails, setVariationDetails] = useState({});
    const [selectedImageVar, setSelectedImageVar] = useState(null); // For main product image
    const [showModalVar, setShowModalVar] = useState(false);
    const [showModalVar1, setShowModalVar1] = useState(false);
    const [imagesVar, setImagesVar] = useState([]);
    const [variationImages, setVariationImages] = useState({}); // Track selected images for each variation
    const [currentVariationId, setCurrentVariationId] = useState(null);
    const [variationGalleryImages, setVariationGalleryImages] = useState({});

    const handleOpenModalVar = (variationId) => {
        setCurrentVariationId(variationId); // Set the variation ID
        setShowModalVar(true); // Open the modal
    };

    const handleCloseModalVar = () => {
        setShowModalVar(false);
    };


    const handleRemoveVariationImage = (variationId) => {
        setVariationImages((prevImages) => {
            const updatedImages = { ...prevImages };
            delete updatedImages[variationId];
            return updatedImages;
        });
    };

    // const updateTypeofSimple = (key, isChecked) => {
    //     const currentTypes = formData.typeofsimple.split(',').filter(Boolean);
    //     let updatedTypes = isChecked
    //         ? [...new Set([...currentTypes, key])]
    //         : currentTypes.filter(type => type !== key);

    //     setFormData((prev) => ({
    //         ...prev,
    //         typeofsimple: updatedTypes.join(',')
    //     }));
    // };

    const updateTypeofSimple = (key, isChecked) => {
        let updatedTypes = formData.typeofsimple.split(',').filter(Boolean);

        if (key === 'virtual' && isChecked) {
            // Add 'virtual', remove 'downloadable'
            updatedTypes = ['virtual'];
        } else if (key === 'downloadable' && isChecked) {
            // Add 'downloadable', remove 'virtual'
            updatedTypes = ['downloadable'];
        } else {
            // Remove the key from selection
            updatedTypes = updatedTypes.filter(type => type !== key);
        }

        setFormData((prev) => ({
            ...prev,
            typeofsimple: updatedTypes.join(',')
        }));
    };

    const updateTypeofCat = (key, isChecked) => {
        let updatedTypes = (formData.categorytype || "").split(',').filter(Boolean);


        if (key === 'Best Sellers' && isChecked) {
            // Add 'virtual', remove 'downloadable'
            updatedTypes = ['Best Sellers'];
        } else if (key === 'Trending' && isChecked) {
            // Add 'downloadable', remove 'virtual'
            updatedTypes = ['Trending'];
        } else {
            // Remove the key from selection
            updatedTypes = updatedTypes.filter(type => type !== key);
        }

        setFormData((prev) => ({
            ...prev,
            categorytype: updatedTypes.join(',')
        }));
    };



    const updateTypeofWar = (key, isChecked) => {
        let updatedTypes = [];

        if (isChecked) {
            // Only allow one selected at a time
            updatedTypes = [key];
        } else {
            // If unchecked, clear selection
            updatedTypes = [];
        }

        setFormData((prev) => ({
            ...prev,
            warranty: updatedTypes.join(','),
        }));
    };


    const updateTypeofWarfrom = (key, isChecked) => {
        let updatedTypes = [];

        if (isChecked) {
            // Only allow one selected at a time
            updatedTypes = [key];
        } else {
            // If unchecked, clear selection
            updatedTypes = [];
        }

        setFormData((prev) => ({
            ...prev,
            warranty_from: updatedTypes.join(','),
        }));
    };

    const updateTypeofInstall = (key, isChecked) => {
        let updatedTypes = [];

        if (isChecked) {
            updatedTypes = [key]; // allow only one selection
        } else {
            updatedTypes = []; // none selected if unchecked
        }

        setFormData((prev) => ({
            ...prev,
            installation: updatedTypes,
        }));
    };

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const categoryOptions = [
        { value: 'electronics', label: 'Electronics' },
        { value: 'fashion', label: 'Fashion' },
        { value: 'home', label: 'Home' },
        { value: 'books', label: 'Books' },
    ];

    const ProductOptions = [
        { value: 'Simple Product', label: 'Simple Product' },
        { value: 'Grouped Product', label: 'Grouped Product' },
        { value: 'External/Affiliate Product', label: 'External/Affiliate Product' },
        { value: 'Variable Product', label: 'Variable Product' },
    ];

    const StockOptions = [
        { value: 'In stock', label: 'In stock' },
        { value: 'Out of stock', label: 'Out of stock' },
        { value: 'Unlimited Stock', label: 'Unlimited Stock' },
    ];

    const handleChange1 = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData((prev) => ({
            ...prev,
            [name]: selectedOption,              // keeps {value: "Electronics", label: "Electronics", id: 5}
            category_id: selectedOption?.id || "" // 👈 stores actual id
        }));
    };

    const handleSelectChangeBrand = (selectedOption, { name }) => {

        setFormData((prev) => ({
            ...prev,
            [name]: selectedOption,               // keep label+value for UI
            brand_id: selectedOption?.value || "", // keep value for backend
        }));
    };


    const handleImageView = async () => {
        const all = await axios.get(`${url}/api/images/${user.main_id}`);
        setImages((all.data).reverse());
    }

    useEffect(() => {
        if (!id) return;
        productHydratedRef.current = false;
        setProductRaw(null);

        const fetchSingleProduct = async () => {
            try {
                const response = await axios.get(`${url}/grouped-product/single/${id}`);
                setProductRaw(response.data);
            } catch (error) {
                console.error("Error fetching product:", error);
                toast.error("Failed to fetch product data");
            }
        };

        fetchSingleProduct();
    }, [id]);

    useEffect(() => {
        if (!productRaw) return;

        const safeParse = (value) => {
            try {
                return typeof value === "string" ? JSON.parse(value) : value || [];
            } catch (e) {
                return [];
            }
        };

        const matchedCategory = matchCategoryOption(categories, productRaw);
        const matchedBrand = matchBrandOption(brand, productRaw);

        if (!productHydratedRef.current) {
            productHydratedRef.current = true;
            setFormData({
                ...productRaw,
                product_type: { label: productRaw.product_type, value: productRaw.product_type },
                category: matchedCategory,
                brand_name: matchedBrand,
                status: { label: productRaw.status, value: productRaw.status },
                stock: { label: productRaw.stock, value: productRaw.stock },
                image: productRaw.image ? [productRaw.image] : [],
                gallery: safeParse(productRaw.gallery),
                key_features: safeParse(productRaw.key_features).map(f => ({
                    id: f?.id || crypto.randomUUID(),
                    text: f?.text || f
                })),
                specifications: safeParse(productRaw.specifications).map(spec => ({
                    ...spec,
                    id: spec.id || crypto.randomUUID()
                })),
                downloadable_files: safeParse(productRaw.downloadable_files),
                grouped_products: safeParse(productRaw.grouped_product),
                brand_id: safeParse(productRaw.brand_id)
            });

            setProductSingle({
                ...productRaw,
                product_type: productRaw.product_type,
                category: matchedCategory,
                brand_name: matchedBrand,
                status: { label: productRaw.status, value: productRaw.status },
                stock: { label: productRaw.stock, value: productRaw.stock },
                image: productRaw.image ? [productRaw.image] : [],
                gallery: safeParse(productRaw.gallery),
                attribute: safeParse(productRaw.attribute),
                variation: safeParse(productRaw.variation),
                key_features: safeParse(productRaw.key_features),
                specifications: safeParse(productRaw.specifications),
                brand_id: safeParse(productRaw.brand_id)
            });
            return;
        }

        setFormData((prev) => ({
            ...prev,
            category: preserveSelectOption(prev.category, matchedCategory),
            brand_name: preserveSelectOption(prev.brand_name, matchedBrand),
            category_id: prev.category_id || productRaw.category_id || "",
        }));
    }, [productRaw, categories, brand]);


    const submitProduct = async (e, { asDraft = false } = {}) => {
        e?.preventDefault?.();
        if (asDraft) {
            setSavingDraft(true);
        } else {
            setLoading(true);
        }
        if (formData.title === "" || formData.title === null) {
            toast.error("Title is required");
            setLoading(false);
            setSavingDraft(false);
            return;
        }
        if (!asDraft) {
            const discountError = getDiscountValidationError(formData, formData.originalPrice, {
                baseLabel: "original price",
            });
            if (discountError) {
                toast.warning(discountError, {
                    position: "top-center",
                    autoClose: 2000,
                });
                setLoading(false);
                setSavingDraft(false);
                return;
            }
        }
        try {
            const payload = {
                ...formData,
                warranty: Array.isArray(formData.warranty)
                    ? formData.warranty[0] || ""
                    : formData.warranty,

                warranty_from: Array.isArray(formData.warranty_from)
                    ? formData.warranty_from[0] || ""
                    : formData.warranty_from,

                installation: Array.isArray(formData.installation)
                    ? formData.installation[0] || ""
                    : formData.installation,
                image: typeof formData.image[0] === 'string'
                    ? formData.image[0]
                    : formData.image[0]?.url || "",
                product_type: formData.product_type?.value || "",
                status: asDraft ? "Inactive" : (formData.status?.value || ""),
                stock: formData.stock?.value || "",
                categorytype: formData.categorytype || "",
                category: formData.category?.value || "",
                grouped_products: formData.grouped_products || [],
                user_id: user.main_id,
                user_name: user.full_name,
                brand_name: resolveBrandName(formData.brand_name),
                gst_type: formData.gst_type,
                gst_percentage: formData.gst_type === "excluded" ? formData.gst_percentage : null,
            };

            const response = await fetch(`${url}/grouped-product/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload)
            });
            const res = await response.json();
            if (response.ok) {
                navigate("/products")
                toast.success(asDraft ? "Draft saved successfully" : "Product Updated successfully", {
                    position: "top-center",
                    autoClose: 2000
                });
            } else {
                toast.warning(res.message)
                console.error("Failed to submit product");
                setLoading(false);
                setSavingDraft(false);
            }

        } catch (error) {
            console.error("Submission error:", error);
        } finally {
            setLoading(false);
            setSavingDraft(false);
        }
    };

    const handleSubmit = (e) => submitProduct(e, { asDraft: false });
    const handleSaveDraft = (e) => submitProduct(e, { asDraft: true });

    const completion = useMemo(
        () => calculateGroupedProductCompletion(formData),
        [formData]
    );

    const [allProducts, setAllProducts] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');;
    const [productSearch, setProductSearch] = useState('');
    const [filteredProducts, setFilteredProducts] = useState([]);

    useEffect(() => {
        axios.get(`${url}/grouped-product/search-all-products/${user.main_id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: { includeInactive: true },
        })
            .then((res) => {
                const filtered = res.data.filter(product => product.product_type !== 'Grouped Product');
                setAllProducts(filtered);
                console.log("Filtered Products:", filtered);
            })
            .catch(console.error);
    }, []);


    useEffect(() => {
        const filtered = productSearch
            ? allProducts.filter(p =>
                p.title.toLowerCase().includes(productSearch.toLowerCase())
            )
            : allProducts; // <-- show all if empty

        setFilteredProducts(filtered);
    }, [productSearch, allProducts]);

    console.log(formData)

    const handleAddToGrouped = (prod) => {
        if (prod.product_type === "Grouped Product") return;

        if (prod.product_type === "Variable Product") {
            setSelectedProduct(prod);
            setShowVariationPopup(true);
        } else {
            setFormData((prev) => ({
                ...prev,
                grouped_products: [...prev.grouped_products, prod],
            }));
        }
    };

    const handleNavigate = (url) => {
        navigate(url)
    };

    const handleCopy = async () => {
        try {
            const confirm = await Swal.fire({
                title: 'Copy Product ?',
                text: `Duplicate "${productSingle.title}" ?`,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Yes, Copy",
            });

            if (!confirm.isConfirmed) return;

            const res = await axios.post(`${url}/grouped-product/copy-product/${productSingle.product_id}`,
                { user_id: user.main_id },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }

            )
            toast.success("Product copied!");
            navigate(`/simple-productedit/${res.data.newProduct.product_id}`);

        } catch (error) {
            toast.error("Copy failed")
        }
    }

    // Convert product list to react-select options
    const productOptions = filteredProducts.map((prod) => ({
        value: prod.id,
        label: prod.title,
        image: getFileIcon(prod.image),
        product_type: prod.product_type,
        prodData: prod,
    }));

    // Convert grouped_products to react-select format for value
    const selectedOptions = formData.grouped_products.map((prod) => ({
        value: prod.id,
        label: prod.title,
        image: getFileIcon(prod.image),
        product_type: prod.product_type,
        prodData: prod,
    }));

    useEffect(() => {
        handleImageView();
        fetchCategories();
        fetchBrand();
    }, [])

    return (
        <>
            <div className="product-form-page">
                <ProductFormChrome
                    title="Edit Grouped Product"
                    subtitle="Update essentials below—expand sections for pricing, SEO, or advanced settings."
                    completion={completion}
                    loading={loading}
                    savingDraft={savingDraft}
                    onSaveDraft={handleSaveDraft}
                    onPublish={handleSubmit}
                    publishLabel="Update Product"
                    publishingLabel="Updating…"
                    extraActions={
                        <button type="button" className="omsnewbutton-copy" onClick={handleCopy}>
                            Duplicate
                        </button>
                    }
                />
                <form className="oms-modal-form property-form product-form-page__form" onSubmit={handleSubmit}>
                    <div className='oms-givepaddingfrom'>
                        <ProductFormSection
                            title="Product Information"
                            description="Core details needed to update and publish a grouped product."
                            alwaysOpen
                        >
                        <div className="oms-form-group">
                            <FormLabel htmlFor="title" required>
                                Product Name
                            </FormLabel>
                            <input
                                type="text"
                                id="title"
                                placeholder="Enter product name"
                                value={formData.title}
                                onChange={handleChange1}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Main Product Image</label>
                            <button
                                type="button"
                                className="image-upload-btn"
                                onClick={() => setShowImageModal(true)}
                            >
                                Choose Product Image
                            </button>
                            {formData.image.length > 0 && (
                                <div className="selected-image-preview">
                                    <img
                                        src={formData.image[0]?.url ? `${url}${formData.image[0].url}` : formData.image[0]}
                                        alt="Selected"
                                    />
                                    <p
                                        className='delete-btnomsprod'
                                        onClick={() => setFormData((prev) => ({ ...prev, image: [] }))}
                                    >
                                        <i className="fa-solid fa-xmark" aria-hidden />
                                    </p>
                                </div>
                            )}
                        </div>
                        <ImageModalEquip
                            show={showImageModal}
                            handleClose={() => setShowImageModal(false)}
                            images={images}
                            onImageSelect={(img) =>
                                setFormData((prev) => ({ ...prev, image: [img] }))
                            }
                            multiple={false}
                            setImages={setImages}
                        />

                        <div className="oms-form-group">
                            <label className="oms-form-label">Product Gallery</label>
                            <button
                                type="button"
                                className="image-upload-btn"
                                onClick={() => setShowImageModalGallery(true)}
                            >
                                Add Additional Images
                            </button>
                            <div className="gallery-preview">
                                {formData.gallery.map((img, index) => (
                                    <div key={index} className="product-form-page__gallery-item">
                                        <img
                                            src={img?.url ? `${url}${img.url}` : img}
                                            alt="gallery"
                                            className='gallery-preview-image'
                                        />
                                        <p
                                            type="button"
                                            className='delete-btnomsprod'
                                            onClick={() => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    gallery: prev.gallery.filter((_, i) => i !== index)
                                                }));
                                            }}
                                        >
                                            <i className="fa-solid fa-xmark" aria-hidden />
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <ImageModalGallery
                            show={showImageModalGallery}
                            handleClose={() => setShowImageModalGallery(false)}
                            images={images}
                            multiple={true}
                            setImages={setImages}
                            onImageSelect={(imgs) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    gallery: Array.isArray(imgs) ? [...prev.gallery, ...imgs] : [...prev.gallery, imgs]
                                }));
                            }}
                        />

                        <div className="oms-form-group">
                            <label htmlFor="short_description" className="oms-form-label">
                                Short Description
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.short_description}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, short_description: value }))
                                }
                                placeholder="Enter Short Description"
                            />
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Category
                            </label>
                            <Select
                                options={categories}
                                placeholder="Select category"
                                name="category"
                                value={formData.category}
                                onChange={handleSelectChange}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="stock" className="oms-form-label">
                                Stock Status
                            </label>
                            <Select
                                options={StockOptions}
                                placeholder="Select Stock Status"
                                name="stock"
                                value={formData.stock}
                                onChange={handleSelectChange}
                            />
                        </div>

                        {
                            formData.stock?.value === "Unlimited Stock" ? null :
                                <div className="oms-form-group">
                                    <label htmlFor="totalStock" className="oms-form-label">
                                        Total Stock
                                    </label>
                                    <input
                                        type="number"
                                        id="totalStock"
                                        placeholder="Enter Total Stock"
                                        value={formData.totalStock}
                                        onChange={handleChange1}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </div>
                        }

                        <div className="oms-form-group">
                            <label htmlFor="status" className="oms-form-label">
                                Product Status
                            </label>
                            <Select
                                options={statusOptions}
                                placeholder="Select status"
                                name="status"
                                value={formData.status}
                                onChange={handleSelectChange}
                            />
                        </div>

                        <div className="product-form-page__section-actions">
                            {loading || savingDraft ? (
                                <button type="button" className="product-form-page__btn-draft" disabled>
                                    {savingDraft ? "Saving draft…" : "Updating…"}
                                </button>
                            ) : (
                                <>
                                    <button type="button" className="product-form-page__btn-draft" onClick={handleSaveDraft}>
                                        Save Draft
                                    </button>
                                    <button type="button" className="oms-add-btn" onClick={handleSubmit}>
                                        Update Product
                                    </button>
                                </>
                            )}
                        </div>
                        </ProductFormSection>

                        <ProductFormSection
                            title="Product Setup"
                            description="Full description, grouped items, features, and product details."
                        >
                        <div className="oms-form-group">
                            <label htmlFor="description" className="oms-form-label">
                                Description
                            </label>
                            <div className="product-form-page__quill">
                                <ReactQuill
                                    theme="snow"
                                    value={formData.description}
                                    onChange={(value) =>
                                        setFormData((prev) => ({ ...prev, description: value }))
                                    }
                                    placeholder="Enter Description"
                                />
                            </div>
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="grouped_products" className="oms-form-label">Grouped Products</label>
                            <Select
                                id="grouped_products"
                                placeholder="Search and select products..."
                                options={productOptions}
                                value={selectedOptions}
                                onChange={(selectedOptions) => {
                                    const grouped = selectedOptions ? selectedOptions.map(opt => opt.prodData) : [];
                                    setFormData(prev => ({ ...prev, grouped_products: grouped }));
                                }}
                                isSearchable
                                isMulti
                            />
                        </div>

                        <div className="oms-form-group ome-form-button2">
                            <label className="oms-form-label">Key Features</label>
                            <div>
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Enter key feature"
                                    value={keyFeatureInput}
                                    onChange={(e) => setKeyFeatureInput(e.target.value)}
                                />
                                <button
                                    type="button"
                                    className="oms-add-btn"
                                    onClick={() => {
                                        if (keyFeatureInput.trim()) {
                                            setFormData((prev) => ({
                                                ...prev,
                                                key_features: [
                                                    ...prev.key_features,
                                                    {
                                                        id: crypto.randomUUID(),
                                                        text: keyFeatureInput.trim()
                                                    }
                                                ]
                                            }));
                                            setKeyFeatureInput('');
                                        }
                                    }}
                                    style={{ marginTop: "10px" }}
                                >
                                    Add More
                                </button>
                            </div>
                            <DndContext
                                collisionDetection={closestCenter}
                                onDragEnd={({ active, over }) => {
                                    if (!over) return;

                                    if (active.id !== over.id) {

                                        const oldIndex = formData.key_features.findIndex(
                                            item => item.id === active.id
                                        );

                                        const newIndex = formData.key_features.findIndex(
                                            item => item.id === over.id
                                        );

                                        const reordered = arrayMove(
                                            formData.key_features,
                                            oldIndex,
                                            newIndex
                                        );

                                        setFormData(prev => ({
                                            ...prev,
                                            key_features: reordered
                                        }));
                                    }
                                }}
                            >
                                <SortableContext
                                    items={(formData?.key_features || []).map(f => f.id)}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <ul className="oms-tag-list">
                                        {(formData?.key_features || []).map(feature => (
                                            <SortableKeyFeature
                                                key={feature.id}
                                                feature={feature}
                                                setFormData={setFormData}
                                            />
                                        ))}
                                    </ul>
                                </SortableContext>
                            </DndContext>
                        </div>

                        {/* Specifications Section */}
                        {/* Specifications */}
                        <div className="oms-form-group ome-form-button2">
                            <label className="oms-form-label">Specifications</label>
                            <div style={{ display: "flex", gap: "10px", marginBottom: "10px", flexWrap: "wrap" }}>
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Label"
                                    value={specInput.label}
                                    onChange={(e) => setSpecInput((prev) => ({ ...prev, label: e.target.value }))}
                                />
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Value"
                                    value={specInput.value}
                                    onChange={(e) => setSpecInput((prev) => ({ ...prev, value: e.target.value }))}
                                />
                                <button
                                    type="button"
                                    className="oms-add-btn"
                                    onClick={() => {
                                        if (specInput.label.trim() && specInput.value.trim()) {
                                            setFormData((prev) => ({
                                                ...prev,
                                                specifications: [...prev.specifications, specInput],
                                            }));
                                            setSpecInput({ label: '', value: '' });
                                        }
                                    }}
                                >
                                    Add More
                                </button>
                            </div>

                            <DndContext
                                collisionDetection={closestCenter}
                                onDragEnd={({ active, over }) => {
                                    if (!over) return;

                                    if (active.id !== over.id) {
                                        const oldIndex = formData.specifications.findIndex(
                                            item => item.id === active.id
                                        );

                                        const newIndex = formData.specifications.findIndex(
                                            item => item.id === over.id
                                        );

                                        const reordered = arrayMove(
                                            formData.specifications,
                                            oldIndex,
                                            newIndex
                                        );

                                        setFormData(prev => ({
                                            ...prev,
                                            specifications: reordered
                                        }));
                                    }
                                }}
                            >
                                <SortableContext
                                    items={(formData?.specifications || []).map(item => item.id)}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <ul className="oms-tag-list">
                                        {(formData?.specifications || []).map((spec, index) => (
                                            <SortableSpecification
                                                key={spec.id}
                                                spec={spec}
                                                index={index}
                                                setFormData={setFormData}
                                            />
                                        ))}
                                    </ul>
                                </SortableContext>
                            </DndContext>
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="brand_name" className="oms-form-label">
                                Brand
                            </label>
                            <Select
                                options={brand}
                                placeholder="Select brand"
                                name="brand_name"
                                value={formData.brand_name}
                                onChange={handleSelectChangeBrand}
                                isClearable
                            />
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="sku" className="oms-form-label">
                                SKU No
                            </label>
                            <input
                                type="text"
                                id="sku"
                                placeholder="Enter SKU No"
                                value={formData.sku}
                                onChange={handleChange1}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="weight" className="oms-form-label">
                                Weight
                            </label>
                            <input
                                type="number"
                                id="weight"
                                placeholder="Enter Weight"
                                value={formData.weight}
                                onChange={handleChange1}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Dimensions (cm)</label>
                            <div className="oms-dimensions-row">
                                <input
                                    type="number"
                                    placeholder="Length"
                                    value={formData.length}
                                    onChange={(e) => setFormData({ ...formData, length: e.target.value })}
                                />
                                <input
                                    type="number"
                                    placeholder="Width"
                                    value={formData.width}
                                    onChange={(e) => setFormData({ ...formData, width: e.target.value })}
                                />
                                <input
                                    type="number"
                                    placeholder="Height"
                                    value={formData.height}
                                    onChange={(e) => setFormData({ ...formData, height: e.target.value })}
                                />
                            </div>
                        </div>
                        </ProductFormSection>

                        <ProductFormSection
                            title="Sales & Store Settings"
                            description="Pricing, merchandising, warranty, delivery, and storefront buttons."
                        >
                        <p className="product-form-page__subsection-title">Pricing</p>
                        <div className="oms-form-group">
                            <label htmlFor="originalPrice" className="oms-form-label">
                                Original Price
                            </label>
                            <input
                                type="number"
                                id="originalPrice"
                                placeholder="Enter original price"
                                value={formData.originalPrice}
                                onChange={handleChange1}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Discount Type</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="radio"
                                        id="discount_price"
                                        name="discount_type"
                                        checked={formData.discount_type === "price"}
                                        onChange={() =>
                                            setFormData(prev => ({
                                                ...prev,
                                                discount_type: "price",
                                                discount_percentage: ""
                                            }))
                                        }
                                    />
                                    <label htmlFor="discount_price">Price</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="radio"
                                        id="discount_percentage"
                                        name="discount_type"
                                        checked={formData.discount_type === "percentage"}
                                        onChange={() =>
                                            setFormData(prev => ({
                                                ...prev,
                                                discount_type: "percentage",
                                                discount_price: ""
                                            }))
                                        }
                                    />
                                    <label htmlFor="discount_percentage">Percentage</label>
                                </div>
                            </div>
                        </div>
                        {formData.discount_type === "price" && (
                            <div className="oms-form-group">
                                <label className="oms-form-label">Discount Price</label>
                                <input
                                    type="number"
                                    placeholder="Enter discount price"
                                    value={formData.discount_price}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormData(prev => {
                                            const updated = {
                                                ...prev,
                                                discount_price: value,
                                                discount_percentage: ""
                                            };
                                            updated.discountPrice = calculateSalePrice(updated);
                                            return updated;
                                        });
                                    }}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        )}
                        {formData.discount_type === "percentage" && (
                            <div className="oms-form-group">
                                <label className="oms-form-label">Discount Percentage (%)</label>
                                <input
                                    type="number"
                                    placeholder="Enter discount percentage"
                                    value={formData.discount_percentage}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormData(prev => {
                                            const updated = {
                                                ...prev,
                                                discount_percentage: value,
                                                discount_price: ""
                                            };
                                            updated.discountPrice = calculateSalePrice(updated);
                                            return updated;
                                        });
                                    }}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        )}
                        <div className="oms-form-group">
                            <label htmlFor="discountPrice" className="oms-form-label">
                                Sale Price
                            </label>
                            <input
                                type="number"
                                id="discountPrice"
                                placeholder="Enter Sale price"
                                value={formData.discountPrice}
                                onChange={handleChange1}
                                readOnly
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Choose Home Category</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Best Sellers"
                                        checked={formData.categorytype?.includes("Best Sellers")}
                                        onChange={(e) => updateTypeofCat("Best Sellers", e.target.checked)}
                                    />
                                    <label htmlFor="Best Sellers">Best Sellers</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Trending"
                                        checked={formData.categorytype?.includes("Trending")}
                                        onChange={(e) => updateTypeofCat("Trending", e.target.checked)}
                                    />

                                    <label htmlFor="Trending">Trending</label>
                                </div>
                            </div>
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="delivery_days" className="oms-form-label">
                                Delivery Days
                            </label>
                            <input
                                type="number"
                                id="delivery_days"
                                placeholder="Enter Delivery within days"
                                value={formData.delivery_days}
                                onChange={handleChange1}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Warranty</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Yes"
                                        checked={formData.warranty.includes("Yes")}
                                        onChange={(e) => updateTypeofWar("Yes", e.target.checked)}
                                    />
                                    <label htmlFor="Yes">Yes</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="No"
                                        checked={formData.warranty.includes("No")}
                                        onChange={(e) => updateTypeofWar("No", e.target.checked)}
                                    />

                                    <label htmlFor="No">No</label>
                                </div>
                            </div>
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Warranty From</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Us"
                                        checked={formData.warranty_from.includes("Us")}
                                        onChange={(e) => updateTypeofWarfrom("Us", e.target.checked)}
                                    />
                                    <label htmlFor="Us">Us</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Company"
                                        checked={formData.warranty_from.includes("Company")}
                                        onChange={(e) => updateTypeofWarfrom("Company", e.target.checked)}
                                    />

                                    <label htmlFor="Company">Company</label>
                                </div>
                            </div>
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="warranty_note" className="oms-form-label">
                                Warranty note
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.warranty_note}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, warranty_note: value }))
                                }
                                placeholder="Enter Warranty Note"
                            />
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Installation</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Free Installation"
                                        checked={formData.installation?.includes("Free Installation")}
                                        onChange={(e) => updateTypeofInstall("Free Installation", e.target.checked)}
                                    />
                                    <label htmlFor="Free Installation">Free Installation</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Paid Installation"
                                        checked={formData.installation?.includes("Paid Installation")}
                                        onChange={(e) => updateTypeofInstall("Paid Installation", e.target.checked)}
                                    />
                                    <label htmlFor="Paid Installation">Paid Installation</label>
                                </div>
                            </div>
                        </div>

                        {
                            formData?.installation && formData?.installation[0] === "Paid Installation" &&
                            <div className="oms-form-group">
                                <label htmlFor="installation_fee" className="oms-form-label">
                                    Installation Fee
                                </label>
                                <input
                                    type="number"
                                    id="installation_fee"
                                    placeholder="Enter Installation Fee"
                                    value={formData.installation_fee}
                                    onChange={handleChange1}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        }

                        <ProductButtonOptions
                            formData={formData}
                            onChange={(field, value) =>
                                setFormData((prev) => ({ ...prev, [field]: value }))
                            }
                        />
                        </ProductFormSection>

                        <ProductFormSection
                            title="SEO & Marketing"
                            description="Search optimization, meta information, tags, and FAQs."
                        >
                        <ProductSeoFields formData={formData} setFormData={setFormData} embedded />
                        </ProductFormSection>

                        <ProductFormSection
                            title="Tax & Compliance"
                            description="GST and HSN details for invoicing and compliance."
                        >
                        <div className="oms-form-group">
                            <label className="oms-form-label">GST Type</label>

                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="radio"
                                        id="gst_included"
                                        name="gst_type"
                                        checked={formData.gst_type === "included"}
                                        onChange={() =>
                                            setFormData(prev => ({
                                                ...prev,
                                                gst_type: "included",
                                                gst_percentage: ""
                                            }))
                                        }
                                    />
                                    <label htmlFor="gst_included">Included GST</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="radio"
                                        id="gst_excluded"
                                        name="gst_type"
                                        checked={formData.gst_type === "excluded"}
                                        onChange={() =>
                                            setFormData(prev => ({
                                                ...prev,
                                                gst_type: "excluded"
                                            }))
                                        }
                                    />
                                    <label htmlFor="gst_excluded">Excluded GST</label>
                                </div>
                            </div>
                        </div>

                        {formData.gst_type === "excluded" && (
                            <div className="oms-form-group">
                                <label className="oms-form-label">GST Percentage (%)</label>
                                <input
                                    type="number"
                                    placeholder="Enter GST percentage e.g. 18"
                                    value={formData.gst_percentage}
                                    onChange={(e) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            gst_percentage: e.target.value
                                        }))
                                    }
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        )}
                        <div className="oms-form-group">
                            <label htmlFor="hsn" className="oms-form-label">
                                HSN CODE
                            </label>
                            <input
                                type="text"
                                id="hsn"
                                placeholder="Enter HSN CODE"
                                value={formData.hsn}
                                onChange={handleChange1}
                            />
                        </div>
                        </ProductFormSection>

                        <ProductFormSection
                            title="AI Product Assistant"
                            description="Generate product content using AI from images or a product URL."
                        >
                        <AIProductAssistant
                            productType="group"
                            defaultOpen={false}
                            onApply={(patch) =>
                                setFormData((prev) => ({ ...prev, ...patch }))
                            }
                        />
                        </ProductFormSection>
                    </div>

                </form >
            </div >
        </>
    );
};

function SortableSpecification({ spec, index, setFormData }) {
    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({ id: spec.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };

    return (
        <li
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            className="oms-tag-item"
        >
            <strong>{spec.label}:</strong> {spec.value}

            <X
                type="button"
                className="oms-tag-delete"
                onClick={() => {
                    setFormData(prev => ({
                        ...prev,
                        specifications: prev.specifications.filter(
                            s => s.id !== spec.id
                        )
                    }));
                }}
                size={14}
            />
        </li>
    );
}
export default GroupedProductEdit;


